import { fontSizes, colors } from "@/app/constants/styles";
import { StyleSheet, ViewStyle, TextStyle } from "react-native";

export const itemOptionsStyles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  optionHeaderContainer: {
    marginBottom: 10,
  },
  optionHeader: {
    fontFamily: "HelveticaNeue-Medium",
    fontSize: fontSizes.x10,
    color: colors.white,
  },
  optionContainer: {
    flex: 0,
  },
  choiceListContainer: {
    backgroundColor: colors.dullWhite,
    borderRadius: 10,
    marginBottom: 20,
    paddingHorizontal: 5,
    paddingTop: 10,
  },
  choiceContainer: {
    flex: 0,
  },
  listSeparator: {
    height: 1,
    backgroundColor: colors.cedar30,
  },
});

type ItemCheckboxStyleType = {
  container: ViewStyle;
  checkboxContainer: ViewStyle;
  optionText: TextStyle;
};

export const itemCheckboxStyles = (enabled: boolean): ItemCheckboxStyleType =>
  StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
    },
    checkboxContainer: {
      backgroundColor: enabled ? colors.dullWhite : colors.maroon,
      borderColor: colors.dullWhite,
      borderWidth: 2,
      borderRadius: 10,
      marginBottom: 20,
      paddingHorizontal: 5,
      paddingVertical: 5,
    },
    optionText: {
      fontFamily: "HelveticaNeue-Medium",
      fontSize: fontSizes.x14,
      color: enabled ? colors.cedar : colors.white,
    },
  });
